// extracted by mini-css-extract-plugin
export default {"info_title":"style_info_title__HuQ7g","info_text":"style_info_text__rk+jF","payment_option_text":"style_payment_option_text__7EKqu","mobile_margin_l":"style_mobile_margin_l__Nt1aO"};